import { Route, Routes } from 'react-router-dom'
import LoginPage from './pages/LoginPage'
import Layout from './components/Layout'
import { CalendarPage } from './pages/CalendarPage'

export function AppRoutes() {
  return (
    <Routes>
      <Route element={<LoginPage />} path="/login" />
      <Route element={<Layout />} path="/">
        <Route element={<CalendarPage />} path="marina/:marinaId" />
      </Route>
    </Routes>
  )
}
